import { DraftV1Actions } from 'client/actions/actionTypes'
import { AddProductInterface } from 'client/actions/draft'
import { actionCreator } from 'client/actions/index'
import { DeliverynoteDraftInterface } from 'client/components/DocumentsV1/Deliverynote/DeliverynoteInterface'
import { ReceiptDraftInterface } from 'client/components/DocumentsV1/Receipt/ReceiptInterface'
import { CustomerInterface } from 'client/Interfaces/CustomerInterface'
import { InvoiceItemType } from 'client/Interfaces/Draft/DraftItemType'
import { LineInterface } from 'client/Interfaces/Draft/LineInterface'
import { DiscountLocation, DiscountType, DiscountVAT } from 'client/Interfaces/Draft/v1/DraftInterface'
import { EditedDraftV1Interface } from 'client/Interfaces/Draft/v1/EditedDraftV1Interface'
import { StateInterface } from 'client/Interfaces/StateInterface'

type DraftInterface = ReceiptDraftInterface | DeliverynoteDraftInterface

export const changeDraftCustomerV1 = actionCreator<CustomerInterface>(DraftV1Actions.DRAFT_V1_CHANGE_CUSTOMER)

export const changeCompanyV1 = actionCreator<EditedDraftV1Interface['company']>(DraftV1Actions.DRAFT_V1_CHANGE_COMPANY)

export const changeDeliverynoteNumberV1 = actionCreator<DeliverynoteDraftInterface['deliverynoteNumber']>(
  DraftV1Actions.DRAFT_V1_CHANGE_DELIVERYNOTE_NUMBER,
)

export const changeInvoiceNumberV1 = actionCreator<EditedDraftV1Interface['invoiceNumber']>(
  DraftV1Actions.DRAFT_V1_CHANGE_INVOICE_NUMBER,
)

export const changeReceiptNumberV1 = actionCreator<ReceiptDraftInterface['receiptNumber']>(
  DraftV1Actions.DRAFT_V1_CHANGE_RECEIPT_NUMBER,
)

export const changeTitleV1 = actionCreator<string>(DraftV1Actions.DRAFT_V1_CHANGE_TITLE)

export const clearDraftV1 = actionCreator<string>(DraftV1Actions.DRAFT_V1_CLEAR)

export const cleanDirtyDraftV1 = actionCreator(DraftV1Actions.DRAFT_V1_CLEAN_DIRTY)

export const changeIssueDateV1 = actionCreator<string>(DraftV1Actions.DRAFT_V1_CHANGE_ISSUE_DATE)

export const changeLinesV1 = actionCreator<InvoiceItemType[]>(DraftV1Actions.DRAFT_V1_CHANGE_LINES)

export const changeDescriptionV1 = actionCreator<string>(DraftV1Actions.DRAFT_V1_CHANGE_DESCRIPTION)

export const changeDiscountAmountV1 = actionCreator<number>(DraftV1Actions.DRAFT_V1_CHANGE_DISCOUNT_AMOUNT)

export const changeFooterTextV1 = actionCreator<string>(DraftV1Actions.DRAFT_V1_CHANGE_FOOTER_TEXT)

export const changeDiscountVatV1 = actionCreator<DiscountVAT>(DraftV1Actions.DRAFT_V1_CHANGE_DISCOUNT_VAT)

export const changeDiscountTypeV1 = actionCreator<DiscountType>(DraftV1Actions.DRAFT_V1_CHANGE_DISCOUNT_TYPE)

export const changeDiscountEnabledV1 = actionCreator<boolean>(DraftV1Actions.DRAFT_V1_CHANGE_DISCOUNT_ENABLED)

export const changeDiscountLocationV1 = actionCreator<DiscountLocation>(
  DraftV1Actions.DRAFT_V1_CHANGE_DISCOUNT_LOCATION,
)

export const addProductLineV1Action = actionCreator<AddProductInterface>(DraftV1Actions.DRAFT_V1_ADD_PRODUCT_LINE)

export const changeColumnsConfigV1 = actionCreator<Array<keyof LineInterface>>(
  DraftV1Actions.DRAFT_V1_CHANGE_COLUMNS_CONFIG,
)

export const changeLanguageV1 = actionCreator<string>(DraftV1Actions.DRAFT_V1_CHANGE_LANGUAGE)

export const changeCurrencyV1 = actionCreator<string>(DraftV1Actions.DRAFT_V1_CHANGE_CURRENCY)

export const changeExchangeRateV1 = actionCreator<number>(DraftV1Actions.DRAFT_V1_CHANGE_EXCHANGE_RATE)

export const changeInvalidFieldsV1 = actionCreator<string[]>(DraftV1Actions.DRAFT_V1_CHANGE_DRAFT_INVALID_FIELDS)

export const previewDraftV1 = actionCreator<StateInterface['preview']>(DraftV1Actions.DRAFT_V1_PREVIEW)

export const clearPreviewDraftV1 = actionCreator(DraftV1Actions.DRAFT_V1_CLEAR_PREVIEW)

export const copyDraftV1 = actionCreator<DraftInterface>(DraftV1Actions.DRAFT_V1_COPY)

export const copyApprovedV1 = actionCreator<DraftInterface>(DraftV1Actions.DRAFT_V1_COPY_APPROVED)

export const saveDraftV1 = actionCreator<DraftInterface>(DraftV1Actions.DRAFT_V1_SAVE_DRAFT)

export const updateDraftV1 = actionCreator<DraftInterface>(DraftV1Actions.DRAFT_V1_UPDATE_DRAFT)

export const updateApprovedV1 = actionCreator<DraftInterface>(DraftV1Actions.DRAFT_V1_UPDATE_APPROVED)

export const loadNewDraftV1 = actionCreator<EditedDraftV1Interface>(DraftV1Actions.DRAFT_V1_LOAD_NEW)

export const loadDraftV1 = actionCreator<DraftInterface>(DraftV1Actions.DRAFT_V1_LOAD)

export const loadApprovedV1 = actionCreator<DraftInterface>(DraftV1Actions.DRAFT_V1_LOAD_APPROVED)
